"use client"

type Win95ButtonProps = {
	label: string
	icon?: string
	active?: boolean
	onClick?: () => void
	className?: string
	fitWidth?: boolean
}

export default function Win95Button({
	label,
	icon,
	active = false,
	onClick,
	className = "",
	fitWidth = false,
}: Win95ButtonProps) {
	return (
		<button
			onClick={onClick}
			className={`
				${fitWidth ? "inline-flex w-fit" : "flex w-full"}
				items-center gap-2
				max-sm:portrait:gap-1
				px-3 py-3
				max-sm:portrait:px-1 max-sm:portrait:py-2
				text-left text-[1rem] font-bold
				max-sm:portrait:text-[0.7rem] max-sm:portrait:justify-center
				select-none
				border-2
				shadow-[0_0_6px_rgba(255,0,128,0.4)]
				hover:shadow-[0_0_10px_2px_#bf00ff]
				${active
					? "bg-[#ffe600] text-black border-t-[#ff003c] border-l-[#ff003c] border-b-[#00f5ff] border-r-[#00f5ff] translate-x-[1px] translate-y-[1px]"
					: "bg-[#0d0020] text-[#39ff14] border-t-[#00f5ff] border-l-[#00f5ff] border-b-[#ff003c] border-r-[#ff003c] active:bg-[#ffe600] active:text-black active:border-t-[#ff003c] active:border-l-[#ff003c] active:border-b-[#00f5ff] active:border-r-[#00f5ff] active:translate-x-[1px] active:translate-y-[1px]"
				}
				${className}
			`}
		>
			{icon && <span className="text-xl leading-none">{icon}</span>}
			<span>{label}</span>
		</button>
	)
}
